import { SearchQuery } from './criteria';
import { EntityFields } from './entity';
import { EntityType } from './entity-type';
import { KeyAndDisplay } from './key-and-display';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';
import { SecurityAccess, TypedSecurityAccess } from './security-access';
import { SecurityStatus } from './security-status';

export enum SearchCatalogFields {
  Name = 'Name',
  EntityType = 'EntityType',
  Criteria = 'Criteria',
}

export interface SearchCatalog {
  [EntityFields.Key]: string | null;
  [EntityFields.Description]: string;
  [SearchCatalogFields.EntityType]: EntityType;
  [SearchCatalogFields.Name]: string;
  [SearchCatalogFields.Criteria]: SearchQuery<unknown>;
  [EntityFields.SecAccess]: SecurityAccess | TypedSecurityAccess<string>;
  [EntityFields.SecStatus]: SecurityStatus;
  [EntityFields.Creator]: KeyAndDisplay;
}

export interface SearchCatalogReadRequest extends Request {
  SearchCatalog: ReadRequest<SearchCatalog>;
}

export interface SearchCatalogReadResponse extends Response {
  SearchCatalog: DataResponse<SearchCatalog>;
}

export interface SearchCatalogWriteRequest extends Request {
  SearchCatalog: WriteRequest<SearchCatalog>;
}

export interface SearchCatalogWriteResponse extends Response {
  SearchCatalog: WriteResponse<SearchCatalog>;
}
